/**
 * Per-student row in Tab "Đánh giá".
 * Shows 3 ScoreInputs + comment textarea.
 * Controlled via React Hook Form field array — parent passes register/control props.
 */
import { Textarea } from '@/components/ui/textarea';
import { ScoreInput } from './score-input';

interface ReviewRowProps {
  index: number;
  studentName: string;
  studentCode?: string | null;
  participation: number | null | undefined;
  comprehension: number | null | undefined;
  behavior: number | null | undefined;
  comment: string;
  onParticipation: (v: number) => void;
  onComprehension: (v: number) => void;
  onBehavior: (v: number) => void;
  onComment: (v: string) => void;
  disabled?: boolean;
}

export function ReviewRow({
  studentName,
  studentCode,
  participation,
  comprehension,
  behavior,
  comment,
  onParticipation,
  onComprehension,
  onBehavior,
  onComment,
  disabled,
}: ReviewRowProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-4 space-y-3">
      {/* Student identity */}
      <div>
        <p className="text-sm font-semibold text-foreground">{studentName}</p>
        {studentCode && (
          <p className="text-xs font-mono text-muted-foreground">{studentCode}</p>
        )}
      </div>

      {/* Score inputs — stack on mobile, row on sm+ */}
      <div className="flex flex-col gap-3 sm:flex-row sm:gap-6">
        <ScoreInput
          label="Tham gia"
          value={participation}
          onChange={onParticipation}
          disabled={disabled}
        />
        <ScoreInput
          label="Hiểu bài"
          value={comprehension}
          onChange={onComprehension}
          disabled={disabled}
        />
        <ScoreInput
          label="Hành vi"
          value={behavior}
          onChange={onBehavior}
          disabled={disabled}
        />
      </div>

      {/* Comment */}
      <Textarea
        value={comment}
        onChange={(e) => onComment(e.target.value)}
        placeholder="Nhận xét (không bắt buộc)"
        className="text-xs h-16 resize-none"
        maxLength={500}
        disabled={disabled}
      />
    </div>
  );
}
